import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
  Input as SemanticInput,
  TextArea as SemanticTextArea,
  Form as SemanticForm,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { calculateRatingColor } from '../../../../core/utils/calculateRatingColor';

export const Container = styled.div`
  padding-top: 10px;
  width: 100%;
`;

const markerColorHandler = {
  qualify: '#0E8249',
  disqualify: '#E8292B',
  'may select': '#C7C7C9',
};

export const FieldValueWrapper = styled.li`
  ${
    ({ type }) => css`
      position: relative;
      list-style-type:none;

      ::before {
        content: "•";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        color: ${type ? markerColorHandler[type] : '#C7C7C9'};
        font-size: 2rem;
      }

      > p {
        margin: 0;
        padding-left: 1rem;
      }
    `
  }
`;

export const FieldName = styled(TextLayoutComponent.Bold)`
`;

export const FieldValue = styled.div`
  word-wrap: break-word;
`;

export const Grid = styled(SemanticGrid)`
 &&& {
    margin-bottom: 0px;
    margin-top: 0px;

    .row {
      padding: 5px 0px;
    }
  }
`;

export const Column = styled(SemanticGrid.Column)``;

export const Row = styled(SemanticGrid.Row)`
  &&& {
    word-wrap: break-word;
  }
`;

export const ContainerQuestion = styled.div`
  margin-bottom: 20px;

  :last-child {
    margin-bottom: 0px;
  }
`;

export const Link = styled.a`
  margin-left: 20px;
`;

export const EditQuestions = styled.a`
  margin-left: 20px;
`;

export const Input = styled(SemanticInput)``;

export const TextArea = styled(SemanticTextArea)``;

export const Form = styled(SemanticForm)``;

export const LearnMoreLink = styled.a`
  font-size: 10px;
`;

export const FieldQuestionRate = styled(TextLayoutComponent)`
  background-color: #F4F4F4;
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px 7px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 12px;
`;

export const ColoredQuestionRating = styled(TextLayoutComponent)`
  background-color: ${(props) => calculateRatingColor(props.percentage)};
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 12px;
`;

export const QuestionOptionAnswerComponent = styled.div`
  display: flex;
`;

export const QuestionOptionList = styled.ul`
  list-style: none;
`;

export const QuestionOptionItem = styled.li`
  display: flex;
`;

export const QuestionOptionPercentage = styled(TextLayoutComponent)`
  background-color: #F0F0F0;
  color: #4D5473;
  border-radius: 5px;
  margin-bottom: 2px !important;
  margin-left: 10px;
  width: auto;
  padding: 0px 8px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const OpenExternal = ({
  href, iconName, iconSize, label,
}) => (
  <span>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
    >
      {label}
      {' '}
      <sup>
        <SemanticIcon name={iconName} size={iconSize} />
      </sup>
    </a>
  </span>
);

OpenExternal.propTypes = {
  href: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  label: PropTypes.string.isRequired,
};

OpenExternal.defaultProps = {
  iconName: 'external alternate icon',
  iconSize: 'small',
};
